/* eslint-disable prefer-const */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/camelcase */
import {
  //Action,
  mkWidget,
  route,
  async,
  Action,
  unloadedAsyncState,
  loadingAsyncState,
  AsyncState,
  none
  //loadingAsyncState,
  //async,
  //string,
  //unloadedAsyncState,
  //any,
  //hn,
  //nothing,
  //div,
  //HttpResult
} from 'widgets-for-react'
import { Map } from 'immutable'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React = require('react')
import { CustomRouteParams } from '../../cms/router/type.gen'
import { getTranslatedCareersSlugTitle, PublicSiteState } from '../../../public_site.main.mod'
import { PublicSiteCustomRoutes, CustomPagesState, CustomPage, TagTitle, TagValues, page_kind_to_tag_list, overview_tag_to_url_tag, overview_tag_to_taxonomy_title } from './types.mod'
import { styleguide as SG } from '../../../styleguide/main.mod'
import * as Api from '../../drupal/api/api.mod'
import { PressReleaseItem } from '../blocks/custom_blocks/widgets/pressReleasesBlock'
import { Breadcrumbs } from '../templates/breadcrumbs.mod'
import { List } from 'immutable'
import { notfound_page } from '../templates/error_page.mod'
import { overviewWidget } from './pages/overviewPage/overview_page_widget'
import { loadOverviewItems, loadTags } from '../../drupal/api/api.mod'
import { decode_tag, PageKind, pageKinds } from './pages/overviewPage/overview_page'
import { add_project_title, getDrupalLanguage, getPage, InitPagesStates, PublicSite_CustomPageData, updateMetaDescription } from '../application.mod'
import { blocks_renderer } from '../blocks/renderer.mod'
import { CustomBlockData } from '../blocks/custom_blocks/types.mod'
import { ExtraImages } from '../utils/extra_images.mod'
import { page } from '../templates/drupal_page.mod'
import { getLangFromUrl } from '../utils/history.mod'
import HeroVisual from '../templates/heroVisual'

export const styleguide: CustomPage<CustomPagesState['styleguide']> = {
  widget: () => mkWidget(SG).never(),
  route: route<{}, CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>>('/en/styleguide', () => ({
    kind: 'styleguide'
  })),
  getState: (s: PublicSiteState) => s.styleguide,
  setState: (s: PublicSiteState, ss: {}) => ({ ...s, styleguide: ss }),
  updateStateBasesOnRoute: (s, r) => (r.kind != 'styleguide' ? s : { ...s, styleguide: { ...s.styleguide } })
}

// export const custom_page1: CustomPage<CustomPagesState['custom_page1']> = {
//   widget: () =>
//     any()([
//       hn(2, 'Hello custom_page1')(nothing()),
//       div()(
//         string({ type: 'text', readonly: true, readonly_element: 'p' })('This is a custom page made with a widget')
//       ),
//       div()(string({ type: 'text', readonly: true, readonly_element: 'p' })(`This link requires no parameters`))
//     ]).never(),
//   route: route<{}, CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>>('/custom_page1', () => ({
//     kind: 'custom_page1'
//   })),
//   getState: (s: PublicSiteState) => s.custom_page1,
//   setState: (s: PublicSiteState, ss: {}) => ({ ...s, custom_page1: ss }),
//   updateStateBasesOnRoute: (s, r) => (r.kind != 'custom_page1' ? s : { ...s, custom_page1: { ...s.custom_page1 } })
// }

export const press: CustomPage<CustomPagesState['press']> = {
  widget: (r) =>
    mkWidget({
      run: (setState: (_: Action<CustomPagesState['press']>) => void) => {
        let press = r.snd
        return press.pressRelease.kind == "loaded" || press.pressRelease.kind == "loading"
          ? (
            <main className="main main--page main--press-release">
              <div className="main__inner">
                <article className="page">
                  {async<PressReleaseItem>()(press.pressRelease).run((a) =>
                    setState((s0) => {
                      return { ...s0, pressRelease: a(s0.pressRelease) }
                    })
                  )}

                  {press.pressRelease.kind == 'loaded' && (
                    <div className="page__inner" lang="en">
                      <header className="pageheader pageheader--flat">
                        <div className="pageheader__inner">
                          <div className="pageheader__content container container--m">
                            <div className="pageheader__message">
                              <div className="pageheader__header">
                                <h1 className="pageheader__title">Press release</h1>
                              </div>
                            </div>
                            {/* <HeroVisual
                              hasFixedImg={false}
                              hasCMSImg={true}
                              hasVacancyImg={false}
                              image={``} 
                            /> */}
                          </div>
                        </div>
                        <Breadcrumbs
                          breadcrumbs={List([
                            {
                              url: '/',
                              title: 'Home'
                            },
                            {
                              url: '/en/press-releases',
                              title: 'Press Releases'
                            },
                            {
                              url: `/en/press-releases/${press.pressRelease.value.id}`,
                              title: press.pressRelease.value.title
                            }
                          ])}
                        />
                      </header>
                      <div className="page__content">
                        <section className="block block--text block--detail">
                          <div className="block__inner container container--m grid--block">
                            <div className="text--styled" dangerouslySetInnerHTML={{ __html: press.pressRelease.value.text }} />
                          </div>
                        </section>
                      </div>
                    </div>
                  )}
                </article>
              </div>
            </main>
          ) : (
            notfound_page(null).run(() => { })
          )
      }
    }),
  route: route<{ page: string }, CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>>('/en/press-releases/:page', (s) => ({
    kind: 'press',
    page: s.page
  })),
  getState: (s: PublicSiteState) => s.press,
  setState: (s: PublicSiteState, ss: CustomPagesState['press']) => ({ ...s, press: ss }),
  updateStateBasesOnRoute: (s, r) =>
    r.kind != 'press'
      ? s
      : {
        ...s,
        press: { page: r.page, pressRelease: loadingAsyncState(() => Api.GetPressRelease<PressReleaseItem>(r.page)) }
      }
}



export const mapPageKindToSlug = (pageKind: PageKind) => {
  let pageKind2: string = pageKind
  switch (pageKind) {
    case 'news-overview':
      pageKind2 = 'actueel'
      break
    case 'vacancy-overview':
      pageKind2 = 'vacancies'
      break
    case 'team-overview':
      pageKind2 = 'medewerkers'
      break
    case 'testimonial-overview':
      pageKind2 = 'testimonials'
      break
  }
  return pageKind2
}

type OverviewParams = {
  slug: string
  page: string
  searchQuery?: string

  industryTag?: string[]
  typeTag?: string[]
  vacancyContractTypeTag?: string[]
  vacancyCountryTag?: string[]
  vacancyStateProvinceTag?: string[]
  vacancyLocationTag?: string[]
  vacancyDepartmentTag?: string[]
  newsTypeTag?: string[]
  teamMemberDisciplineTag?: string[]
  testimonialTag?: string[]
}

function mapOverviewParam(s: OverviewParams): OverviewParams {
  if (s.industryTag == undefined) s.industryTag = []
  if (s.typeTag == undefined) s.typeTag = []
  if (s.vacancyContractTypeTag == undefined) s.vacancyContractTypeTag = []
  if (s.vacancyCountryTag == undefined) s.vacancyCountryTag = []
  if (s.vacancyStateProvinceTag == undefined) s.vacancyStateProvinceTag = []
  if (s.vacancyLocationTag == undefined) s.vacancyLocationTag = []
  if (s.vacancyDepartmentTag == undefined) s.vacancyDepartmentTag = []
  if (s.newsTypeTag == undefined) s.newsTypeTag = []
  if (s.teamMemberDisciplineTag == undefined) s.teamMemberDisciplineTag = []
  if (s.testimonialTag == undefined) s.testimonialTag = []
  return Object.entries(s).reduce((xs, x) => {
    if (x[0].includes('industryTag') && x[0] != 'industryTag') typeof (x[1]) == "string" ? (xs.industryTag).push(x[1]) : (xs.industryTag).push(...x[1])
    if (x[0].includes('typeTag') && x[0] != 'typeTag') typeof (x[1]) == "string" ? (xs.typeTag).push(x[1]) : (xs.typeTag).push(...x[1])
    if (x[0].includes('vacancyContractTypeTag') && x[0] != 'vacancyContractTypeTag') typeof (x[1]) == "string" ? (xs.vacancyContractTypeTag).push(x[1]) : (xs.vacancyContractTypeTag).push(...x[1])
    if (x[0].includes('vacancyCountryTag') && x[0] != 'vacancyCountryTag') typeof (x[1]) == "string" ? (xs.vacancyCountryTag).push(x[1]) : (xs.vacancyCountryTag).push(...x[1])
    if (x[0].includes('vacancyStateProvinceTag') && x[0] != 'vacancyStateProvinceTag') typeof (x[1]) == "string" ? (xs.vacancyStateProvinceTag).push(x[1]) : (xs.vacancyStateProvinceTag).push(...x[1])
    if (x[0].includes('vacancyLocationTag') && x[0] != 'vacancyLocationTag') typeof (x[1]) == "string" ? (xs.vacancyLocationTag).push(x[1]) : (xs.vacancyLocationTag).push(...x[1])
    if (x[0].includes('vacancyDepartmentTag') && x[0] != 'vacancyDepartmentTag') typeof (x[1]) == "string" ? (xs.vacancyDepartmentTag).push(x[1]) : (xs.vacancyDepartmentTag).push(...x[1])
    if (x[0].includes('newsTypeTag') && x[0] != 'newsTypeTag') typeof (x[1]) == "string" ? (xs.newsTypeTag).push(x[1]) : (xs.newsTypeTag).push(...x[1])
    if (x[0].includes('teamMemberDisciplineTag') && x[0] != 'teamMemberDisciplineTag') typeof (x[1]) == "string" ? (xs.teamMemberDisciplineTag).push(x[1]) : (xs.teamMemberDisciplineTag).push(...x[1])
    if (x[0].includes('testimonialTag') && x[0] != 'testimonialTag') typeof (x[1]) == "string" ? (xs.testimonialTag).push(x[1]) : (xs.testimonialTag).push(...x[1])
    return xs
  }, s)
}

export const overviewPage = (): CustomPage<CustomPagesState['overview']> => {
  return {
    widget: (input) =>
      overviewWidget(
        loadOverviewItems
      )({
        routes: input.fst,
        state: input.snd
      }),
    route: route<OverviewParams, CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>>
      (`/:lang?/${getTranslatedCareersSlugTitle().slug[getLangFromUrl()]}/:slug(${pageKinds.map(x => mapPageKindToSlug(x)).join('|')})/:page(\\d+)?/`, (s) => {
        s = mapOverviewParam(s)
        return {
          kind: 'overview',
          slug: s.slug,
          page: s.page && parseInt(s.page),
          searchQuery: s.searchQuery,

          industryTag: typeof (s.industryTag) == "string" ? [s.industryTag] : s.industryTag,
          typeTag: typeof (s.typeTag) == "string" ? [s.typeTag] : s.typeTag,
          vacancyContractTypeTag: typeof (s.vacancyContractTypeTag) == "string" ? [s.vacancyContractTypeTag] : s.vacancyContractTypeTag,
          vacancyCountryTag: typeof (s.vacancyCountryTag) == "string" ? [s.vacancyCountryTag] : s.vacancyCountryTag,
          newsTypeTag: typeof (s.newsTypeTag) == "string" ? [s.newsTypeTag] : s.newsTypeTag,
          teamMemberDisciplineTag: typeof (s.teamMemberDisciplineTag) == "string" ? [s.teamMemberDisciplineTag] : s.teamMemberDisciplineTag,
          testimonialTag: typeof (s.testimonialTag) == "string" ? [s.testimonialTag] : s.testimonialTag,
          vacancyLocationTag: typeof (s.vacancyLocationTag) == "string" ? [s.vacancyLocationTag] : s.vacancyLocationTag,
          vacancyStateProvinceTag: typeof (s.vacancyStateProvinceTag) == "string" ? [s.vacancyStateProvinceTag] : s.vacancyStateProvinceTag,
          vacancyDepartmentTag: typeof (s.vacancyDepartmentTag) == "string" ? [s.vacancyDepartmentTag] : s.vacancyDepartmentTag,
        }
      }),
    getState: (s: PublicSiteState) => s.overview,
    setState: (
      ps: PublicSiteState,
      overviewState: CustomPagesState['overview']
    ) => {
      if (overviewState.page_template_state.page.page.kind == "loaded") {
        document.title = add_project_title(`${overviewState.page_template_state.page.page.value.extra_data.node.metatag.title}`)
        updateMetaDescription(overviewState.page_template_state.page.page.value.extra_data.node.metatag.description)
      }
      return {
        ...ps,
        overview: overviewState,
        // cookiestate: overviewState.cookiestate
      }
    },
    updateStateBasesOnRoute: (s, r) => {
      if (s.overview.page_template_state.page.page.kind == "loaded") {
        document.title = add_project_title(`${s.overview.page_template_state.page.page.value.extra_data.node.metatag.title}`)
        updateMetaDescription(s.overview.page_template_state.page.page.value.extra_data.node.metatag.description)
      }
      if (r.kind != 'overview') return s
      let pageKind: PageKind = r.slug
        .toLowerCase()
        ?.startsWith('resource-overview')
        ? 'resource-overview'
        : r.slug.toLocaleLowerCase()?.startsWith('vacancies') ? 'vacancy-overview'
          : r.slug.toLocaleLowerCase()?.startsWith('medewerkers') ? 'team-overview'
            : r.slug.toLocaleLowerCase()?.startsWith('actueel') ? 'news-overview'
              : r.slug.toLocaleLowerCase()?.startsWith('testimonials') ? 'testimonial-overview'
                : 'search-overview'
      let tags = Map<TagTitle, TagValues>();

      page_kind_to_tag_list(pageKind).forEach(t => {
        let url_tag = overview_tag_to_url_tag(t)
        tags = tags.set(t, r[url_tag] ? r[url_tag].map((r) => decode_tag(r)) : [])
      })

      let new_overview = empty_overview()(
        s,
        true,
        pageKind,
        tags,
        r.page,
        r.searchQuery
      )
      let should_reload_details = false
      if (
        s.overview.overview_page.kind == 'unloaded' ||
        s.overview.pageKind != r.slug
      ) {
        if (s.overview.pageKind != "vacancy-overview") {
          new_overview.overview_page =
            getPage(r.slug, [])

          should_reload_details = true
        }
      } else {
        new_overview.overview_page = s.overview.overview_page
        new_overview.page_template_state.page =
          s.overview.page_template_state.page
      }

      page_kind_to_tag_list(pageKind).forEach(tag => {
        if (s.overview.tags.get(tag) == undefined || s.overview.tags.get(tag).kind == "unloaded") {

          let tags = Map<TagTitle, TagValues>();

          page_kind_to_tag_list(pageKind).forEach(t => {
            tags = tags.set(t, r[overview_tag_to_url_tag(t)] ? r[overview_tag_to_url_tag(t)].map((x) => decode_tag(x)) : [])
          })

          new_overview.tags = new_overview.tags.set(tag,
            loadTags(
              new_overview.pageKind,
              getDrupalLanguage(getLangFromUrl()),
              overview_tag_to_taxonomy_title(tag),
              tags
            ))
        } else {
          new_overview.tags = new_overview.tags.set(tag, s.overview.tags.get(tag))
        }
      })

      let are_arrays_different = (arr1: string[], arr2: string[]) => arr1.filter(x => arr2 && !arr2.includes(x)).length > 0
      let are_tags_different = false;

      page_kind_to_tag_list(pageKind).forEach(t => {
        if (are_tags_different) return
        let state_Tag = s.overview.selected_options.tags.get(t)
        if (state_Tag == undefined) return
        are_tags_different = state_Tag && are_arrays_different(state_Tag, r[overview_tag_to_url_tag(t)])
      })

      if (
        should_reload_details ||
        s.overview.selected_options.currentPage != r.page ||
        are_tags_different) {

        let tags = Map<TagTitle, TagValues>();

        page_kind_to_tag_list(pageKind).forEach(t => {
          tags = tags.set(t, r[overview_tag_to_url_tag(t)] ? r[overview_tag_to_url_tag(t)].map((x) => decode_tag(x)) : [])
        })

        new_overview.overview_items =
          loadOverviewItems(
            new_overview.pageKind,
            tags,
            r.searchQuery,
            r.page,
            10,
            getDrupalLanguage(getLangFromUrl())

          )
      } else {
        new_overview.overview_items = s.overview.overview_items
      }
      s.page.page = unloadedAsyncState()
      return { ...s, overview: new_overview }
    }

  }
}

export let empty_overview = () => (
  s: PublicSiteState,
  // cookiebarstate: CookiebarState,
  load_page: boolean,
  page_kind?: PageKind,
  tags?: Map<TagTitle, TagValues>,
  page_number?: number,
  searchQuery?: string
): CustomPagesState['overview'] => {
  const initPagesStates = InitPagesStates(blocks_renderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>())
  let p = page(none())({ fst: List(), snd: none() })
  return {
    overview_page: unloadedAsyncState(),
    tags: Map<TagTitle, AsyncState<TagValues>>(),
    overview_items: unloadedAsyncState(),
    selected_options: {
      tags: tags || Map(),
      currentPage: page_number || 0,
      searchQuery: searchQuery || ''
    },
    // cookiestate: cookiebarstate,
    pageKind: page_kind || 'resource-overview',
    page_template_state: {
      // cookiestate: cookiebarstate,
      page: {
        ...initPagesStates.page,
        page:
          load_page && page_kind ?
            getPage(mapPageKindToSlug(page_kind), [])
            : initPagesStates.page.page,
        display: p
      }
    }
  }
}


